import React from 'react';
import { Card, CardContent } from '@/shared/components/ui/Card';
import type { CampaignStatsResponse } from '@troia-v3/types';
import { Icon } from '@/shared/icons'
import type { IconName } from '@/shared/icons'
interface CampaignStatsCardsProps {
  stats: CampaignStatsResponse;
}

interface StatCardConfig {
  label: string;
  value: number;
  icon: IconName;
  color: string;
  bgColor: string;
  rate?: number;
  rateLabel?: string;
}

/**
 * Campaign Stats Cards Component
 * Displays 5 stat cards in a responsive grid with metrics
 */
export const CampaignStatsCards: React.FC<CampaignStatsCardsProps> = ({ stats }) => {
  const cards: StatCardConfig[] = [
    {
      label: 'Total Destinatários',
      value: stats.totalRecipients || 0,
      icon: 'users',
      color: 'var(--theme-primary)',
      bgColor: 'var(--theme-primary-background, rgba(139, 92, 246, 0.1))',
    },
    {
      label: 'Enviadas',
      value: stats.messagesSent || 0,
      icon: 'send',
      color: 'var(--theme-info-color)',
      bgColor: 'var(--theme-info-background)',
    },
    {
      label: 'Entregues',
      value: stats.messagesDelivered || 0,
      icon: 'check-circle',
      color: 'var(--theme-success-color)',
      bgColor: 'var(--theme-success-background)',
      rate: stats.deliveryRate || 0,
      rateLabel: 'taxa de entrega',
    },
    {
      label: 'Lidas',
      value: stats.messagesRead || 0,
      icon: 'eye',
      color: '#8b5cf6',
      bgColor: 'rgba(139, 92, 246, 0.1)',
      rate: stats.readRate || 0,
      rateLabel: 'taxa de leitura',
    },
    {
      label: 'Falhas',
      value: stats.messagesFailed || 0,
      icon: 'x-circle',
      color: 'var(--theme-error-color)',
      bgColor: 'var(--theme-error-background)',
      rate: stats.failureRate || 0,
      rateLabel: 'taxa de falha',
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
      {cards.map((card) => {
        return (
          <Card key={card.label}>
            <CardContent className="px-4 pb-4 pt-4">
              <div className="flex items-center gap-3">
                <div
                  className="flex items-center justify-center w-10 h-10 rounded-lg flex-shrink-0"
                  style={{ backgroundColor: card.bgColor }}
                >
                  <Icon name={card.icon} size={20} style={{ color: card.color }} />
                </div>
                <div className="min-w-0">
                  {/* Mockup `.dstat-top`: valor (20px/800) ACIMA do label */}
                  <p className="text-xl font-extrabold" style={{ color: 'var(--theme-card-text)' }}>
                    {card.value.toLocaleString()}
                  </p>
                  <p className="text-xs truncate" style={{ color: 'var(--theme-muted-text)' }}>
                    {card.label}
                  </p>
                </div>
              </div>
              {card.rate !== undefined && (
                <div className="mt-2">
                  <span
                    className="text-xs font-medium px-2 py-0.5 rounded-full"
                    style={{
                      backgroundColor: card.bgColor,
                      color: card.color,
                    }}
                  >
                    {card.rate.toFixed(1)}% {card.rateLabel}
                  </span>
                </div>
              )}
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
